angular.module("vgresiduos").component("loginStatusChecker", {
	controller: "LoginStatusCheckerCtrl",
	templateUrl: "views/afterLoginIdentityProvider/components/loginResponse/loginStatusChecker_template.html",
	bindings: {}
});
